import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import DashboardComponent from './dashboardComponent';
import {getDashboardAccount} from '../../../app/store/reducers/dashboard';
import {getOpenComponent, getOpenItem} from '../../../app/store/reducers/menu';
import {getAccounts} from '../../../app/store/reducers/entities';
import {getIsStakeAdmin} from '../../../app/store/reducers/session';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {fontAwesomeIcons} from '../../utils/icons';
import {Stack, Typography} from '@mui/material';

const AccountDashboard = ({createHandleMenuClick}) => {
    const type = 'Portfolio';
    const [accountsData, setAccountsData] = useState([]);

    const dashboardAccount = useSelector(getDashboardAccount);
    const openItem = useSelector(getOpenItem);
    const openComponent = useSelector(getOpenComponent);
    const accounts = useSelector(getAccounts);
    const isActive = openItem === type.toLowerCase() && openComponent == 'home';
    const isStakeAdmin = useSelector(getIsStakeAdmin);

    useEffect(() => {
        if (accounts.length > 0) {
            const accountsData = accounts.map((account) => {
                return {
                    sfid: account.sfid,
                    name: account.name
                };
            });

            let newAccountsData = [];
            if (isStakeAdmin) {
                newAccountsData = [
                    {
                        sfid: 'add',
                        name: (
                            <Stack direction={'row'} columnGap={1} alignItems={'center'}>
                                <FontAwesomeIcon icon={fontAwesomeIcons.faPlus} color="#149CE0" />
                                <Typography variant="body1" color="#149CE0">
                                    Add an account
                                </Typography>
                            </Stack>
                        )
                    }
                ];
            }
            newAccountsData = [...newAccountsData, ...accountsData];
            setAccountsData(newAccountsData);
        }
    }, [dashboardAccount, accounts]);

    return (
        <DashboardComponent
            type={type}
            dashboardObj={dashboardAccount}
            isLoading={false}
            isSuccess={true}
            data={accountsData}
            createHandleMenuClick={createHandleMenuClick}
            isActive={isActive}
        />
    );
};

AccountDashboard.propTypes = {
    createHandleMenuClick: PropTypes.func
};

export default AccountDashboard;
